/**
 * Copyright (c) 2022 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import { useContext, useMemo } from 'react';
import { StyleSheet, StyleDeclaration } from 'aphrodite';
import { ConsumerAppConfigContext } from '../contexts/appConfig';
export { ConsumerAppConfigContext } from '../contexts/appConfig';

interface UseConsumerTheme {
  appConfig: ConsumerAppConfigContext;
  styles: StyleDeclaration;
}

export type GenerateStyles = (appConfig: ConsumerAppConfigContext) => {};

export const useConsumerTheme = (generateStyles?: GenerateStyles): UseConsumerTheme => {
  const appConfig = useContext(ConsumerAppConfigContext);
  const styles = useMemo(
    () => (!!generateStyles ? StyleSheet.create(generateStyles(appConfig)) : {}),
    [generateStyles, appConfig],
  );
  return { appConfig, styles };
};
